import React from 'react';
import { LazyComponent } from '../LazyComponent';
import { useReportingContext } from '../Context';

const lazyImport = () =>
    import(/* webpackChunkName: 'ReportContentModal' */ './index').then((module) => ({
        default: module.ReportContentModal,
    }));

export const LazyReportContentModal = ({ onError = () => null }) => {
    const { isModalOpen, closeModal } = useReportingContext();

    if (!isModalOpen) return null;

    return (
        <LazyComponent
            lazyImport={lazyImport}
            shouldImport={isModalOpen}
            source="LazyReportContentModal"
            onError={onError}
            componentProps={{ isModalOpen, onClose: closeModal }}
        />
    );
};
